var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-search-user",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("img", {
        staticClass: "triangle",
        attrs: { src: require("../../images/top-v.png") },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "search-content" }, [
        _c("div", { staticClass: "input-wrap" }, [
          _c("div", { staticClass: "search-icon" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchValue,
                expression: "searchValue",
              },
            ],
            staticClass: "search-input",
            attrs: {
              type: "text",
              placeholder: "搜索用户昵称",
              id: "searchInput",
            },
            domProps: { value: _vm.searchValue },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchValue = $event.target.value
                },
                _vm.onInput,
              ],
              focus: _vm.onFocus,
            },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "delete-icon",
            on: { click: _vm.deleteValue },
          }),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "user-list" },
          [
            _vm._l(_vm.searchData, function (item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "user-item",
                  on: {
                    click: function ($event) {
                      _vm.selectUser(item)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "avatar" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.setPicSize(
                          item.avatar || _vm.defaultAvatar,
                          48,
                          48
                        ),
                        alt: "",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-content" }, [
                    _c("div", {
                      staticClass: "name",
                      domProps: {
                        innerHTML: _vm._s(_vm.replaceValue(item.nickname)),
                      },
                    }),
                    _vm._v(" "),
                    item.type == 1
                      ? _c("span", { staticClass: "tag" }, [_vm._v("作者")])
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            _vm._v(" "),
            !_vm.searchData.length && !_vm.loading
              ? _c("div", { staticClass: "noData" }, [
                  _c("div", { staticClass: "empty-cover" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text" }, [
                    _vm._v("请搜索查找用户"),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }